import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const ComponentStatusDiv = ({
    equipment, 
    equipmentComponents, 
    componentId, 
    equipmentPartsByComponentId, 
    hasControlData, 
    hasTimelineData, 
    isPannelLoaded=true, 
    target="default"
}) => {
    const { t } = useTranslation();
    const [isPannelView, setIsPannelView] = useState(false);
    const [pannelBgColor, setPannelBgColor] = useState('#000');

    const didInitRef = useRef(false);
    
    useEffect(()=>{
        if (didInitRef.current || !isPannelLoaded) return;

        const isNoData = !equipment?.latestEquipmentOp && (!hasControlData && !hasTimelineData);
// console.log(isNoData)
        if (isNoData) {
            // if (equipmentComponents?.length > 0) {
            //     equipmentPartsByComponentId(equipmentComponents[0].id); // 첫번째 구성부
            // }
            equipmentPartsByComponentId(-3);    // 사진/도면
            
            didInitRef.current = true;
            return;
        } else {
            if (hasControlData || hasTimelineData) {
                equipmentPartsByComponentId(-1);    // 운전/진단
            } else {
                if (equipmentComponents?.length > 0) {
                    equipmentPartsByComponentId(equipmentComponents[0].id); // 첫번째 구성부
                }
            }
            didInitRef.current = true;
        }
    }, [
        isPannelLoaded,
        equipment?.latestEquipmentOp,
        hasControlData, 
        hasTimelineData, 
        equipmentComponents
    ])

    useEffect(()=>{
        // if (equipment?.equipmentCtgr?.parent?.parent?.code === 'EV' || equipment?.equipmentCtgr?.parent?.parent?.code === 'ES') {
        // if (didInitRef.current) return;
        if (equipment?.latestEquipmentOp || hasControlData || hasTimelineData) {
            setIsPannelView(true);
            if (equipment?.latestEquipmentOp?.controlPanelCode?.alertYn === 'Y') {
                if (componentId===-1)
                    setPannelBgColor('3px solid #ed1c24');
                else
                    setPannelBgColor('1px solid #ed1c24');
            } else {
                if (componentId===-1)
                    setPannelBgColor('3px solid #0061d0');
                else
                    setPannelBgColor('1px solid #0061d0');
            }
        // } else {
        //     setIsPannelView(false);
        //     if (equipmentComponents?.length > 0 && !componentId) {
        //         equipmentPartsByComponentId(equipmentComponents[0].id)
        //     }
        }
    },[isPannelView, componentId, equipmentPartsByComponentId, hasControlData, hasTimelineData])
    
    const hasPanelTab = isPannelView;
    const hasComponentTab = equipmentComponents && equipmentComponents.length > 0;
    const hasAnyTab = hasPanelTab || hasComponentTab;

    if (!hasAnyTab) return null;

    return (
        <div style={{padding:"0 20px"}}>
        {isPannelView && 
            <p className="statustab1" style={{cursor:"pointer", display:"inline-block", padding:"3px 9px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`${pannelBgColor}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{equipmentPartsByComponentId(-1)}}>{t('message.common.chip.panel')}</p>
        }
        <p className="statustab4" style={{cursor:"pointer", display:"inline-block", padding:"8px 9px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`${componentId === -3 ? "3px solid #0061d0": "1px solid #0061d0"}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{equipmentPartsByComponentId(-3)}}>{t('message.common.tabTitle.picture.data')}</p>
        {equipmentComponents && equipmentComponents.map(function(item, i) {
            let componentName = item.name;
            let bgColor = "3px solid #0061d0";
            let defaultBgColor = "1px solid #0061d0";
            // if (target === 'default' && item.sensorYn) {
            // if (target === 'maintenance' || target === 'default') {
                if (item.countFaultCodesOfAlertY && item.countFaultCodesOfAlertY > 0) {
                    bgColor = "3px solid #ed1c24";
                    defaultBgColor = "1px solid #ed1c24";
                } else if (item.countFaultCodesOfAlertN && item.countFaultCodesOfAlertN > 0) {
                    bgColor = "3px solid #e5a846";
                    defaultBgColor = "1px solid #e5a846";
                } else {
                    bgColor = "3px solid #0061d0";
                    defaultBgColor = "1px solid #0061d0";
                }

                if (item.status === 'NORMAL') {
                    componentName += '<span class="instate1">'+t('message.common.text.available')+'</span>';//유효
                    // bgColor = "#5b9bd5";
                } else if (item.status === 'ALERT') {
                    componentName += '<span class="instate2">'+t('message.common.text.imminent')+'</span>';//임박
                    // bgColor = "#ff0000";
                } else if (item.status === 'EXPIRED') {
                    componentName += '<span class="instate3">'+t('message.common.text.lapse')+'</span>';//경과
                    // bgColor = "#2c2c2c";
                }
           
                const isSelected = componentId === item.id;
                return (
                    <p className={isSelected ? "statustab2":"statustab3"} key={i} style={{cursor:"pointer", display:"inline-block", padding:"3px 5px", margin:"2px 10px 2px 0", borderRadius:"100px", border:isSelected ? bgColor : defaultBgColor, backgroundColor:"#000", color:"#fff"}} onClick={()=>{equipmentPartsByComponentId(item.id)}} dangerouslySetInnerHTML={ {__html: componentName} }></p>
                )
            // }
        }) }
        </div>
    )
}

export default ComponentStatusDiv;